export const locales = ["az", "en", "ru"];
export const defaultLocale = "az";
